<dialog id="deviceModal" class="modal">
  <div class="modal-box">
    <h3 class="font-bold text-lg">Device Registration</h3>
    <p class="py-4">Please enable your device to continue.</p>
    <div class="modal-action">
      <button type="button" class="btn btn-primary" (click)="onEnableDevice()">Enable Device</button>
      <!-- <button type="button" class="btn" (click)="onCancel()">Cancel</button> -->
    </div>
  </div>
</dialog>
